module.exports = require("element-ui/lib/locale/lang/zh-CN");